import { FC, useEffect, useMemo } from "react";
import { SelectOption } from "../../utils/models";

import { getFacilities, loadFacilities } from "../../store/facilities";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";

import * as utils from "../../utils/utilities";

function withFacilities(Component: any): FC<any> {
  return function WithFacilities(props): JSX.Element {
    const dispatch = useAppDispatch();
    const facilities = useAppSelector(getFacilities);

    const facilitiesForDropdown = useMemo((): SelectOption[] => {
      return facilities.facilities.map(utils.transformFacilityItem);
    }, [facilities.facilities]);

    const refreshFacilities = (): void => {
      return dispatch(loadFacilities() as any);
    };

    useEffect(() => {
      refreshFacilities();

      // eslint-disable-next-line
    }, []);

    return (
      <Component
        facilities={facilities.facilities}
        facilitiesForDropdown={facilitiesForDropdown}
        facilitiesLoading={facilities.loading}
        facilitiesError={facilities.error}
        facilitiesLastUpdated={facilities.lastUpdated}
        refreshFacilities={refreshFacilities}
        {...props}
      />
    );
  };
}

export default withFacilities;
